import React, { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Common_Form from "./Common_Form";
import { useDispatch } from "react-redux";
import {
  GetAllState,
  GetState,
  UpdateState,
} from "../../../../../features/admin/masters/state/Slice";

const Edit_User = ({
  show,
  id, // pass the user id to edit
  setShow,
  setErr,
  handleClose,
  setSuccess,
}) => {
  const dispatch = useDispatch();
  const [defaultValues, setDefaultValues] = useState({});
  const [loading, setLoading] = useState(false);

  const [showError, setShowError] = useState({});
  const GetData = async (id) => {
    try {
      setLoading(true);
      const res = await dispatch(GetState(id));
      if (res.meta?.requestStatus === "fulfilled") {
        setDefaultValues({
          name: res?.payload?.data.name,
          country_id: res?.payload?.data?.country_id,
        });
      }
    } catch (error) {
      console.error(error);
      setErr(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show) {
      GetData(id);
    }
  }, [show]);

  // Submit handler
  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();

      // sendData.append("name", data?.name);
      // sendData.append("country_id", data?.country_id?.value);

      const res = await dispatch(UpdateState({ id: id, data }));

      if (res.payload.success) {
        dispatch(GetAllState());
        setTimeout(() => {
          setSuccess(false);
          handleClose();
        }, 1500);
        setShow(false);
        setSuccess(true);
      } else {
        setShowError(res.payload.errors);
      }
    } catch (error) {
      console.error(error);
      setErr(true);
    }
  };

  return (
    <Offcanvas
      className="mobile_offcanvas common_offcanvas"
      show={show}
      placement="end"
      onHide={handleClose}
      scroll={false}
      backdrop={true}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          <div className="back_div" onClick={handleClose}>
            <Common_Back_Btn />
          </div>
          Edit State
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="add_form">
          {!loading && (
            <Common_Form
              handleClose={handleClose}
              onSubmit={onSubmit}
              defaultValues={defaultValues}
              showError={showError}
              success={false}
            />
          )}
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default Edit_User;
